import React from "react"
import { classNames } from "../../components/utils/Utils"
import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const CustomSoundStatusGraph = ({ currentStatus }) => {
    const statusList = ['Requested', 'Prepared', 'Converted', 'Exported', 'Completed'];
    const currentIndex = statusList.findIndex(s => s.toLowerCase() === currentStatus?.toLowerCase());

    return (
        <div className="flex flex-col md:flex-row justify-between items-center gap-2 py-2 mb-5">
            {statusList.map((status, index) => {
                const isPast = index < currentIndex;
                const isCurrent = index === currentIndex;
                const isFuture = index > currentIndex;

                return (
                    <React.Fragment key={index}>
                        <div
                            className={classNames(
                                "border rounded px-6 py-4 transition-all duration-300 text-sm text-center flex-1 w-full md:w-auto",
                                isPast && "text-purple-500 border-purple-500",
                                isCurrent && "text-purple-500 border-purple-500",
                                (isCurrent && index !== statusList.length - 1) && "animate-pulse font-semibold",
                                isFuture && "text-gray-400 border-gray-300"
                            )}
                        >
                            {status}
                        </div>

                        {index < statusList.length - 1 && (
                            <FontAwesomeIcon
                                icon={faAngleDoubleRight}
                                className={classNames(
                                    "w-4 h-4 mx-auto md:mx-0 md:rotate-0 rotate-90",
                                    index < currentIndex ? "text-purple-500" : "text-gray-400"
                                )}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default CustomSoundStatusGraph